import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { LOCAL_DATE_FORMATS } from 'src/app/shared/utility/date';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatSnackBarModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatIconModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSliderModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatMomentDateModule,
        MatProgressSpinnerModule
    ],
    providers: [{ provide: MAT_DATE_FORMATS, useValue: LOCAL_DATE_FORMATS }],
    exports: [
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatSelectModule,
        MatSnackBarModule,
        MatDatepickerModule,
        MatCheckboxModule,
        MatIconModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatSliderModule,
        MatNativeDateModule,
        MatTableModule,
        MatPaginatorModule,
        MatMomentDateModule,
        MatProgressSpinnerModule
    ],
    declarations: []
})
export class MaterialModule {}
